import React from 'react';
import ReactDOM from 'react-dom/client';
import { createInstance, MatomoProvider } from '@jonkoops/matomo-tracker-react';
import '@styles/global.css';
import "leaflet/dist/leaflet.css";
import App from './App';

const matomoInstance = createInstance({
    urlBase: 'https://vld-boisleroi.fr/matomo',
    siteId: 1,
    disabled: false, // Optionnel : mettre true pour désactiver
    heartBeat: { // Optionnel : pour tracker le temps passé
        active: true,
        seconds: 15
    },
    linkTracking: true, // Optionnel : tracker les clics sur les liens
    configurations: { // Optionnel : configurations avancées
        disableCookies: true, // RGPD - pas de cookies
        setSecureCookie: true,
        setRequestMethod: 'POST'
    }
});

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <MatomoProvider value={matomoInstance}>
        <App />
    </MatomoProvider>
);